module.exports = __webpack_public_path__ + "static/img/COC2021-6.32d5e65.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-6.jpg
// module id = G3Km
// module chunks = 0